import { createContext, useEffect, useState } from "react";
import { formatEther, formatUnits } from "viem";
import { useAccount, usePublicClient } from "wagmi";
import {
  DAO_CONTRACT_ADDRESS,
  ERC20_ABI,
  ERC20_CONTRACT_ADDRESS,
  LP_CONTRACT_ADDRESS,
  LP2_CONTRACT_ADDRESS,
  BURN2MINT_CONTRACT_ADDRESS,
  BURN2MINT_ABI,
} from "../lib/constants";

// initial state
const defaultValues = {
  supply: 0,
  liquidity:0,
  liquidity2:0,
  burned:0,
  staked:0,
  minted:0,
  getMetrics: () => {},
};
// context
export const MetricsContext = createContext(defaultValues);

export const MetricsProvider = ({ children }) => {
  const publicClient = usePublicClient();
  const { address, isConnected } = useAccount();

  const [state, setMetrics] = useState({
    supply: 0,
    liquidity:0,
    liquidity2:0,
    burned:0,
    staked:0,
    minted:0,
  });
 
  const getMetrics = async (address) => {
    //try {
      const [supply, liquidity, liquidity2, burned, staked, minted] = await Promise.all([
        publicClient.readContract({
          abi: ERC20_ABI,
          address: ERC20_CONTRACT_ADDRESS,
          functionName: "totalSupply",
          args: [],
        }),
        publicClient.readContract({
          abi: ERC20_ABI,
          address: ERC20_CONTRACT_ADDRESS,
          functionName: "balanceOf",
          args: [LP_CONTRACT_ADDRESS],
        }),
        publicClient.readContract({
          abi: ERC20_ABI,
          address: ERC20_CONTRACT_ADDRESS,
          functionName: "balanceOf",
          args: [LP2_CONTRACT_ADDRESS],
        }),
        publicClient.readContract({
          abi: ERC20_ABI,
          address: ERC20_CONTRACT_ADDRESS,
          functionName: "balanceOf",
          args: ["0x000000000000000000000000000000000000dEaD"],
        }),
        publicClient.readContract({
          abi: ERC20_ABI,
          address: ERC20_CONTRACT_ADDRESS,
          functionName: "balanceOf",
          args: [DAO_CONTRACT_ADDRESS],
        }),
        publicClient.readContract({
          abi: BURN2MINT_ABI,
          address: BURN2MINT_CONTRACT_ADDRESS,
          functionName: "minted",
          args: [],
        }),
      ]);

      setMetrics({
        supply: formatEther(supply || "0"),
        liquidity: formatEther(liquidity || "0"),
        liquidity2: formatEther(liquidity2 || "0"),
        burned: formatEther(burned || "0"),
        staked: formatEther(staked || "0"),
        minted: formatEther(minted || "0"),
      });


    //} catch (err) {}
    
  };

  useEffect(() => {
    isConnected && getMetrics(address);
    // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [address, isConnected]);

  return (
    <MetricsContext.Provider value={{ ...state, getMetrics }}>
      {children}
    </MetricsContext.Provider>
  );
};
